//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import stepTitle from "../StepTitle";
export default {
  props: {
    viewData: {
      default: () => {}
    },
    data: {
      default: () => []
    },
    titleStep: {
       type: Number,
       default: 1 
    },
    titleName: {
       type: String,
       default: '合約期' 
    },
  },
  data() {
      return {
          active: 0,
          showShrink:true,
      }
  },
  mounted() {
    
  },
  methods: {
      selected(index, item) {
          if(index == this.active) return;
          if(!index) return console.warn('請傳入參數');
          this.active = index;
          this.$emit('change', item);
      },
			isOpen(val){//打开或者关闭伸缩
				if(val==1){
					this.showShrink=false;
				}else{
					this.showShrink=true;
				}
			}
  },
  components: {
    stepTitle
  }
};
